import { render, staticRenderFns } from "./GameLevelsDetail.vue?vue&type=template&id=44fc5c9c&scoped=true"
import script from "./GameLevelsDetail.vue?vue&type=script&lang=ts"
export * from "./GameLevelsDetail.vue?vue&type=script&lang=ts"
import style0 from "./GameLevelsDetail.vue?vue&type=style&index=0&id=44fc5c9c&lang=scss"
import style1 from "./GameLevelsDetail.vue?vue&type=style&index=1&id=44fc5c9c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fc5c9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\sandy\\Desktop\\EIOSYS\\Admin\\Alembic-Grow-Admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44fc5c9c')) {
      api.createRecord('44fc5c9c', component.options)
    } else {
      api.reload('44fc5c9c', component.options)
    }
    module.hot.accept("./GameLevelsDetail.vue?vue&type=template&id=44fc5c9c&scoped=true", function () {
      api.rerender('44fc5c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game-levels/components/GameLevelsDetail.vue"
export default component.exports